import { GetLoadables } from '../loader';
let exported = [
    'completionKeysXML',
    'autoComplete',
    'getKeyMap',
    'CodeMirror_Pos'
];
let loader = ()=>null;
// #if process.env.UIX_CHUNKED === 'true'
loader = ()=>{
    return import(/* webpackChunkName: 'codemirror' */ './loadCodemirror');
};
const CM = GetLoadables(loader, [
    'CodeMirror',
    'UnControlledCodeMirror',
    'DiffView'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as CM from './loadCodemirror'
// exported = {
//   completionKeysXML: CM.completionKeysXML,
//   autoComplete: CM.autoComplete,
//   getKeyMap: CM.getKeyMap,
//   CodeMirror_Pos: CM.CodeMirror_Pos,
// }
// #endif
export let { CodeMirror, UnControlledCodeMirror, DiffView } = CM;
export const exportedEditor = {
    names: exported,
    loader
};
